import React, { Component } from 'react'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

import ARF_1_small from '../../images/ARF-0001_logo.png'
import ARF_1_big from '../../images/ARF-0001_big.png'
import ARF_2_small from '../../images/ARF-0002_logo.jpg'
import ARF_2_big from '../../images/ARF-0002_big.jpg'
import ARF_3_small from '../../images/ARF-0003_logo.png'
import ARF_3_big from '../../images/ARF-0003_big.png'

const PRODUCTS = [
    {
        name: 'ARF_1',
        small_src: ARF_1_small,
        big_src: ARF_1_big,
        value: 15000,
        valueStr: '₡15 000'
    },
    {
        name: 'ARF_2',
        small_src: ARF_2_small,
        big_src: ARF_2_big,
        value: 25000,
        valueStr: '₡25 000'
    },
    {
        name: 'ARF_3',
        small_src: ARF_3_small,
        big_src: ARF_3_big,
        value: 40000,
        valueStr: '₡40 000'
    }
]

class CustomProductPicker extends Component {

    constructor(props){
        super(props)
        this.state = {
            isOpen: false,
            productIndex: ''
        }
    }

    render(){
        const {productsSelected, onProductSelected} = this.props
        const {isOpen, productIndex} = this.state
        const productNamesSelected = productsSelected.map(el => {return el.name})
        return(
            <div>
                <div className="line-header-text">Enviar ofrenda</div>
                <div className="container-event-details-product-picker">
                {
                    PRODUCTS.map((product, index) => {
                        return (
                        <div className="product-photo-container">
                             <div
                                className='product-photo'
                                onClick={event => {
                                    this.setState({isOpen: true, productIndex: index})
                                }}
                            >
                                <img src={product.small_src} alt={product.name} width="100%" height="100%"/>
                                {
                                    productNamesSelected.includes(product.name) ?
                                    <span className="cover-image"></span>:<div></div>
                                }
                            </div>
                            <input
                                type="checkbox"
                                id={product.name}
                                name={product.name}
                                value={product.name}
                                checked={productNamesSelected.includes(product.name)}
                                onChange={() => onProductSelected(product.name, product.value)}
                            />
                            <label
                                className={productNamesSelected.includes(product.name) ? "product-selected-text": "product-price"}
                                htmlFor={product.name}>
                                {product.valueStr}
                            </label>
                        </div>
                        )
                    })
                }
                </div>
                {
                    isOpen ?
                        <Lightbox
                            mainSrc={PRODUCTS[productIndex].big_src}
                            nextSrc={PRODUCTS[(productIndex + 1) % PRODUCTS.length]}
                            prevSrc={PRODUCTS[(productIndex + PRODUCTS.length - 1) % PRODUCTS.length]}
                            onCloseRequest={() => this.setState({ isOpen: false })}
                            onMovePrevRequest={() =>
                              this.setState({
                                productIndex: (productIndex + PRODUCTS.length - 1) % PRODUCTS.length,
                              })
                            }
                            onMoveNextRequest={() =>
                              this.setState({
                                productIndex: (productIndex + 1) % PRODUCTS.length,
                              })
                            }
                        /> : <div></div>
                }
                <div className="subtitle-info-product-picker inline-element">**Pagos se realizan por medio de SINPE móvil</div>
            </div>
        )
    }
}

export default CustomProductPicker
